import { Injectable } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { UserService } from '../service/auth/user.service';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(
        private userService: UserService,
        private permissionService: NgxPermissionsService,
    ) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.userService.getUserPermission()
            .then((data) => {
                this.permissionService.loadPermissions(data);

                if (localStorage.getItem('logged')) {
                    return true;
                }
                else {
                    window.location.href = "/techbyte/admin/login";
                    return false;
                }
            })
            .catch(e => {
                window.location.href = "/techbyte/admin/login";
                return false;
            });
    }
}